module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Leimbach_AG-2f2520a604f1dd7998fb5c964a1d88ec.svg";